import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useSplitTestIdSelector = (id: string) => {
  const state = useGetEditOrActual();

  return state.splitTests[id]?.splitTestId;
};
